<div class="report-details" style="padding-top: 1rem;">

  @for (action of availableActions(); track action.id) {

  <!-- Active / Unban / Unsuspend -->
  @if (action.id === 'active') {
  <div class="section-container action-card mt-2" [class.action-card-selected]="selectedAction() === 'active'"
    (click)="toggleAction('active')">
    <div class="action-card-title">
      <p-radioButton name="moderationAction" value="active" [ngModel]="selectedAction()" inputId="action-active" />
      <span class="info-icon ml-2" [pTooltip]="action.tooltip" tooltipPosition="top" (click)="$event.stopPropagation()">
        <i class="pi pi-info-circle icon-primary"></i>
      </span>
      <label for="action-active" class="section-title m-0 ml-2" style="cursor: pointer;">{{ action.label }}</label>
    </div>

    @if (selectedAction() === 'active' && accountStatus() !== 'active') {
    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Reason</label>
      <textarea pInputTextarea [(ngModel)]="activeReason" rows="3"
        placeholder="Required if reversing a report-linked status" class="w-100"></textarea>
    </div>
    }
  </div>
  }

  <!-- Deactivate -->
  @if (action.id === 'deactivate') {
  <div class="section-container action-card mt-2" [class.action-card-selected]="selectedAction() === 'deactivate'"
    (click)="toggleAction('deactivate')">
    <div class="action-card-title">
      <p-radioButton name="moderationAction" value="deactivate" [ngModel]="selectedAction()"
        inputId="action-deactivate" />
      <span class="info-icon ml-2" [pTooltip]="action.tooltip" tooltipPosition="top" (click)="$event.stopPropagation()">
        <i class="pi pi-info-circle icon-primary"></i>
      </span>
      <label for="action-deactivate" class="section-title m-0 ml-2" style="cursor: pointer;">{{ action.label }}</label>
    </div>
  </div>
  }

  <!-- Ban -->
  @if (action.id === 'ban') {
  <div class="section-container action-card mt-4" [class.action-card-selected]="selectedAction() === 'ban'"
    (click)="toggleAction('ban')">
    <div class="action-card-title">
      <p-radioButton name="moderationAction" value="ban" [ngModel]="selectedAction()" inputId="action-ban" />
      <span class="info-icon ml-2" [pTooltip]="action.tooltip" tooltipPosition="top" (click)="$event.stopPropagation()">
        <i class="pi pi-info-circle icon-primary"></i>
      </span>
      <label for="action-ban" class="section-title m-0 ml-2" style="cursor: pointer;">Ban</label>
    </div>

    @if (selectedAction() === 'ban') {
    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Ban reason</label>
      <p-select [options]="reasonOptions" [(ngModel)]="banReason" optionLabel="label" optionValue="value"
        placeholder="Select a reason…" [style]="{ width: '100%' }" appendTo="body" />
    </div>

    <div class="field-group mt-3 flex align-items-center gap-2" (click)="$event.stopPropagation()">
      <input type="checkbox" id="sendBanEmailCb" [(ngModel)]="sendBanEmail" />
      <label for="sendBanEmailCb" class="info-label m-0">Send email notification</label>
    </div>

    @if (sendBanEmail()) {
    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Email subject</label>
      <input type="text" pInputText [(ngModel)]="banEmailSubject" class="w-100" />
    </div>

    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Email description</label>
      <textarea pInputTextarea [(ngModel)]="banEmailBody" rows="5" class="w-100"></textarea>
    </div>
    }
    }
  </div>
  }

  <!-- Suspend -->
  @if (action.id === 'suspend') {
  <div class="section-container action-card mt-4" [class.action-card-selected]="selectedAction() === 'suspend'"
    (click)="toggleAction('suspend')">
    <div class="action-card-title">
      <p-radioButton name="moderationAction" value="suspend" [ngModel]="selectedAction()" inputId="action-suspend" />
      <span class="info-icon ml-2" [pTooltip]="action.tooltip" tooltipPosition="top" (click)="$event.stopPropagation()">
        <i class="pi pi-info-circle icon-primary"></i>
      </span>
      <label for="action-suspend" class="section-title m-0 ml-2" style="cursor: pointer;">Suspend</label>
    </div>

    @if (selectedAction() === 'suspend') {
    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Suspend reason</label>
      <p-select [options]="reasonOptions" [(ngModel)]="suspendReason" optionLabel="label" optionValue="value"
        placeholder="Select a reason…" [style]="{ width: '100%' }" appendTo="body" />
    </div>

    <div class="row g-3 mt-1">
      <div class="col-md-6 field-group" (click)="$event.stopPropagation()">
        <label class="info-label">Suspend services</label>
        <p-multiSelect [options]="serviceOptions" [(ngModel)]="suspendedServices" optionLabel="label"
          optionValue="value" placeholder="Select services to suspend…" [style]="{ width: '100%' }" appendTo="body" />
      </div>
      <div class="col-md-6 field-group" (click)="$event.stopPropagation()">
        <label class="info-label">Suspension length (days)</label>
        <input type="number" pInputText [(ngModel)]="suspendDays" min="1" placeholder="e.g. 7" class="w-100" />
      </div>
    </div>

    <div class="field-group mt-3 flex align-items-center gap-2" (click)="$event.stopPropagation()">
      <input type="checkbox" id="sendSuspendEmailCb" [(ngModel)]="sendSuspendEmail" />
      <label for="sendSuspendEmailCb" class="info-label m-0">Send email notification</label>
    </div>

    @if (sendSuspendEmail()) {
    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Email subject</label>
      <input type="text" pInputText [(ngModel)]="suspendEmailSubject" class="w-100" />
    </div>

    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Email description</label>
      <textarea pInputTextarea [(ngModel)]="suspendEmailBody" rows="5" class="w-100"></textarea>
    </div>
    }
    }
  </div>
  }

  <!-- Review (Reports only) -->
  @if (action.id === 'review') {
  <div class="section-container action-card mt-4" [class.action-card-selected]="selectedAction() === 'review'"
    (click)="toggleAction('review')">
    <div class="action-card-title">
      <p-radioButton name="moderationAction" value="review" [ngModel]="selectedAction()" inputId="action-review" />
      <span class="info-icon ml-2" [pTooltip]="action.tooltip" tooltipPosition="top" (click)="$event.stopPropagation()">
        <i class="pi pi-info-circle icon-primary"></i>
      </span>
      <label for="action-review" class="section-title m-0 ml-2" style="cursor: pointer;">Mark as reviewed</label>
    </div>

    @if (selectedAction() === 'review') {
    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Email subject (optional)</label>
      <input type="text" pInputText [(ngModel)]="reviewEmailSubject" placeholder="Update on your report"
        class="w-100" />
    </div>

    <div class="field-group mt-3" (click)="$event.stopPropagation()">
      <label class="info-label">Email description (optional)</label>
      <textarea pInputTextarea [(ngModel)]="reviewEmailBody" rows="5" placeholder="Let the user know what was found…"
        class="w-100"></textarea>
    </div>
    }
  </div>
  }

  }

  <div class="d-flex justify-content-end gap-2 w-full mt-4">
    <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="cancelForm()"></p-button>
    <p-button label="Submit" [disabled]="!canSubmit()" (onClick)="openConfirm()" styleClass="submit-btn"></p-button>
  </div>
</div>

<p-dialog [(visible)]="showConfirm" [modal]="true" [style]="{ width: '24vw', 'max-width': '420px' }" [breakpoints]="{ '640px': '90vw' }"
  [draggable]="false" [resizable]="false" styleClass="confirm-dialog" appendTo="body">
  <div class="confirm-content-wrapper" style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 0.75rem; padding: 0.25rem 0 0.5rem 0;">
    <div class="confirm-icon-container" [ngClass]="selectedAction()" style="width: 72px; height: 72px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 2.2rem; margin-bottom: 0.25rem;">
      @if (selectedAction() === 'ban') {
        <i class="pi pi-ban text-red-500" style="color: #ef4444;"></i>
      } @else if (selectedAction() === 'suspend') {
        <i class="pi pi-exclamation-triangle text-amber-500" style="color: #f59e0b;"></i>
      } @else if (selectedAction() === 'active') {
        <i class="pi pi-check-circle text-green-500" style="color: #22c55e;"></i>
      } @else if (selectedAction() === 'deactivate') {
        <i class="pi pi-power-off text-gray-500" style="color: #64748b;"></i>
      } @else {
        <i class="pi pi-info-circle text-blue-500" style="color: #3b82f6;"></i>
      }
    </div>

    <p class="confirm-message" style="margin: 0; font-size: 1.05rem; color: #374151; font-weight: 500;">
      Are you sure you want to change the status to <strong>{{ selectedAction() }}</strong> for
      {{ userName() }}?
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2 w-full">
      <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="cancelConfirm()"></p-button>
      <p-button label="Confirm" severity="danger" (onClick)="confirmAction()"></p-button>
    </div>
  </ng-template>
</p-dialog>
